<template>
  <div class='carousel is-5 carousel-animated carousel-animate-slide'>
    <div class='carousel-container'>
      <div class='carousel-item is-active'>
        <figure class="image is-2by1"><img src="https://bulma.io/images/placeholders/640x320.png"></figure>
      </div>
      <div class='carousel-item'>
        <figure class="image is-2by1"><img src="https://bulma.io/images/placeholders/640x320.png"></figure>
      </div>
      <div class='carousel-item'>
        <figure class="image is-2by1"><img src="https://bulma.io/images/placeholders/640x320.png"></figure>
      </div>
      <div class='carousel-item'>
        <figure class="image is-2by1"><img src="https://bulma.io/images/placeholders/640x320.png"></figure>
      </div>
      <div class='carousel-item'>
        <figure class="image is-2by1"><img src="https://bulma.io/images/placeholders/640x320.png"></figure>
      </div>
      <div class='carousel-item'>
        <figure class="image is-2by1"><img src="https://bulma.io/images/placeholders/640x320.png"></figure>
      </div>
      <div class='carousel-item'>
        <figure class="image is-2by1"><img src="https://bulma.io/images/placeholders/640x320.png"></figure>
      </div>
    </div>
    <div class="carousel-navigation is-centered">
      <div class="carousel-nav-left">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
      </div>
      <div class="carousel-nav-right">
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reusable/Carousel.vue